export default "__VITE_ASSET__3e308aa4__"